import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { IconPresentation } from '../Icon/IconPresentation.js';
import { hostClass } from './Thumbnail.styles.js';

var ThumbnailPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var id = props.id,
    className = props.className,
    icon = props.icon,
    iconName = props.iconName,
    iconVariant = props.iconVariant,
    iconTitle = props.iconTitle,
    text = props.text,
    src = props.src,
    imgAltText = props.imgAltText,
    noMargin = props.noMargin,
    size = props.size;
  return /*#__PURE__*/React.createElement(Host, {
    id: id,
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, !!className), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _defineProperty(_cleanupClassObject, "".concat(hostClass, "__size-").concat(size), size), _cleanupClassObject))
  }, (iconName || icon) && /*#__PURE__*/React.createElement(IconPresentation, {
    icon: icon,
    name: iconName,
    variant: iconVariant,
    size: "small",
    title: iconTitle,
    noMargin: true
  }), text && /*#__PURE__*/React.createElement("div", {
    className: "".concat(hostClass, "__text")
  }, text), src && /*#__PURE__*/React.createElement("img", {
    className: "".concat(hostClass, "__img"),
    src: src,
    alt: imgAltText
  }));
});
ThumbnailPresentation.displayName = "ThumbnailPresentation";

export { ThumbnailPresentation };
